import actionTypes from '../actions/roomType/actionType';

const defaultRoomType = {
  name: '',
};

const initialState = {
  tableLoading: false,
  dataList: [],
  currentPage: 1,
  total: 10,
  modalVisible: false,
  modalType: 'add',
  reloadList: false,
  currentItem: defaultRoomType,
  allRoomType: [],
  allRoomTypeDatasource: [],
  roomCategories: [],
  newModalVisible: false,
  newModalType: 'detail',
  roomData: {},
  tagList: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.TABLE_LOADING:
      const { tableLoading } = payload;
      return {
        ...state,
        tableLoading,
      };
    case actionTypes.ALL_ROOM_TYPE_LOADING:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.FETCH_ROOMTYPE_LIST:
      const { dataList, currentPage, total } = payload;
      return {
        ...state,
        dataList,
        currentPage,
        total,
      };
    case actionTypes.TOGGLE_ROOMTYPE_MODAL_VISIBLE:
      const { modalVisible, modalType } = payload;
      return {
        ...state,
        modalVisible,
        modalType,
      };
    case actionTypes.RELOAD_ROOMTYPE_LIST:
      const { reloadList } = payload;
      return {
        ...state,
        reloadList,
      };
    case actionTypes.SAVE_CURRENT_ROOMTYPE:
      const { currentItem } = payload;
      return {
        ...state,
        currentItem,
      };
    case actionTypes.FETCH_ALL_ROOMTYPE:
      const { allRoomType, allRoomTypeDatasource } = payload;
      return {
        ...state,
        allRoomType,
        allRoomTypeDatasource,
      };
    case actionTypes.FETCH_ROOM_CATEGORIES:
      const { roomCategories } = payload;
      return {
        ...state,
        roomCategories,
      };
    case actionTypes.FETCH_ROOM_TYPE_DETAIL:
      const { detailData } = payload;
      return {
        ...state,
        roomData: detailData,
      };
    case actionTypes.TOGGLE_ROOMTYPE_NEW_MODAL_VISIBLE:
      const { newModalVisible, newModalType } = payload;
      return {
        ...state,
        newModalVisible,
        newModalType,
      };
    case actionTypes.UPDATE_CURRENT_ROOM_TYPEL:
      const { key, value } = payload;
      const { roomData } = state;
      return {
        ...state,
        roomData: {
          ...roomData,
          [key]: value,
        },
      };
    case actionTypes.FETCH_TAG_LIST:
      const { list } = payload;
      return {
        ...state,
        tagList: list,
      };
    default:
      return state;
  }
};
